import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, Input, Radio } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { RadioChangeEvent } from 'antd/lib/radio';

const { useFormInstance, useWatch } = Form;

interface TaskTimeProps {
	taskTimeFieldName: NamePath;
	taskTimeFormatFieldName: NamePath;
}

export const TaskTime: React.FC<TaskTimeProps> = ({ taskTimeFieldName, taskTimeFormatFieldName }) => {
	const form = useFormInstance();
	const task_time_format = useWatch(taskTimeFormatFieldName, form);

	const options = [
		{
			value: 'seconds',
			label: I18n.get('Seconds')
		},
		{
			value: 'minutes',
			label: I18n.get('Minutes')
		}
	];

	const placeHolder = options.find(({ value }) => value === task_time_format);

	function handlePreventNonNumericInput(e: React.KeyboardEvent<HTMLInputElement>) {
		if (e.key === 'Backspace' || e.key === 'Delete') return;

		if (task_time_format !== 'minutes' && (e.key === ',' || e.key === '.')) {
			e.preventDefault();
			return;
		}

		if (!/[\d,.]/.test(e.key)) {
			e.preventDefault();
			return;
		}

		const value = e.currentTarget.value;
		const hasDecimal = value.includes('.') || value.includes(',');

		switch (e.key) {
			case '.':
			case ',':
				if (hasDecimal || value.length === 0) {
					e.preventDefault();
				}
				break;
			default:
				if (hasDecimal) {
					const decimalPart = value.split(/[.,]/)[1];
					if (decimalPart?.length >= 1) {
						e.preventDefault();
					}
				}
				break;
		}
	}

	function handleOnChangeTimeFormat(e: RadioChangeEvent) {
		const value = form.getFieldValue(taskTimeFieldName);
		if (value && e.target.value === 'seconds') {
			const integerValue = String(value).split(/[.,]/)[0];
			form.setFieldValue(taskTimeFieldName, integerValue);
		}
	}

	return (
		<Col xs={24} sm={24} md={12} lg={8}>
			<Row align="middle">
				<Col span={24}>
					<Row align="middle">
						<Col span={20}>
							<Form.Item
								name={taskTimeFieldName}
								label={I18n.get('Task time')}
								labelCol={{ span: 24 }}
								rules={[
									{
										required: true,
										message: I18n.get('Insert a task duration')
									}
								]}
							>
								<Input
									min={1}
									style={{ width: '90%' }}
									placeholder={I18n.get(placeHolder?.label ?? 'Seconds')}
									onKeyDown={handlePreventNonNumericInput}
								/>
							</Form.Item>
						</Col>
						<Col span={4}>
							<Form.Item name={taskTimeFormatFieldName} label={' '} labelCol={{ span: 24 }}>
								<Radio.Group
									style={{ display: 'flex' }}
									options={options}
									defaultValue={I18n.get('seconds')}
									onChange={handleOnChangeTimeFormat}
								/>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
};
